'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

var _effects = require('redux-saga/effects');

var sagaEffects = _interopRequireWildcard(_effects);

var _sagaHelpers = require('redux-saga/lib/internal/sagaHelpers');

var _messages = require('../core/messages');

var _messages2 = _interopRequireDefault(_messages);

var _actionType = require('./actionType');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ### saga类
// > see: https://github.com/dvajs/dva/blob/d74d3d7ce1dafeb5e9d009aae4307b305305b288/packages/dva-core/src/index.js
var Saga = function () {
  function Saga() {
    (0, _classCallCheck3.default)(this, Saga);

    this._watchersMap = {};
    this._effects = {};
  }

  (0, _createClass3.default)(Saga, [{
    key: '_wrapped',
    value: function _wrapped(type, fn, payload) {
      if (this._watchersMap[type]) delete this._watchersMap[type];
      fn(payload);
    }
  }, {
    key: '_watch',
    value: function _watch(type, resolve, reject) {
      this._watchersMap[type].resolve = this._wrapped.bind(this, type, resolve);
      this._watchersMap[type].reject = this._wrapped.bind(this, type, reject);
    }
  }, {
    key: '_getWatchPromise',
    value: function _getWatchPromise(type) {
      if (this._watchersMap[type]) {
        return this._watchersMap[type].promise;
      } else {
        this._watchersMap[type] = {};
        return this._watchersMap[type].promise = new Promise(this._watch.bind(this, type));
      }
    }
  }, {
    key: 'getMiddleware',
    value: function getMiddleware(getModel) {
      var _this = this;

      return function () {
        return function (next) {
          return function (action) {
            if (action.name) {
              action.type = (0, _actionType.actionToType)(action.name);
            }
            if (action.type) {
              var _decodeActionType = (0, _actionType.decodeActionType)(action.type),
                  _decodeActionType2 = (0, _slicedToArray3.default)(_decodeActionType, 2),
                  modelName = _decodeActionType2[0],
                  actionName = _decodeActionType2[1];

              var model = getModel(modelName);
              if (model && actionName) {
                if (model.effects[actionName]) {
                  // 得出resolve 和 reject交付给saga，不再往下走
                  return _this._getWatchPromise(action.type);
                } else if (action.name && model.actions[actionName]) {
                  return model.actions[actionName].apply(model, action.payload && action.payload.arguments)(model.dispatch);
                } else {
                  return next(action);
                }
              } else {
                return next(action);
              }
            } else {
              return next(action);
            }
          };
        };
      };
    }
  }, {
    key: 'resolve',
    value: function resolve(type, payload) {
      if (this._watchersMap[type]) {
        this._watchersMap[type].resolve(payload);
      }
    }
  }, {
    key: 'reject',
    value: function reject(type, payload) {
      if (this._watchersMap[type]) {
        this._watchersMap[type].reject(payload);
      }
    }
  }, {
    key: 'effect',
    value: function effect(model) {
      if (!arguments.length) {
        return this._effects;
      } else if (typeof model === 'string') {
        return this._effects[model];
      } else if (model.effects) {
        var self = this;
        model._emitter = this._createEffects(model);
        var effect = /*#__PURE__*/_regenerator2.default.mark(function effect() {
          var _this2 = this;

          var _loop, key;

          return _regenerator2.default.wrap(function effect$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _loop = /*#__PURE__*/_regenerator2.default.mark(function _loop(key) {
                    var watcher, task;
                    return _regenerator2.default.wrap(function _loop$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            watcher = self._getWatcher(model, key, model.effects[key]);
                            _context2.next = 3;
                            return sagaEffects.fork(watcher);

                          case 3:
                            task = _context2.sent;
                            _context2.next = 6;
                            return sagaEffects.fork( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                              return _regenerator2.default.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.next = 2;
                                      return sagaEffects.take((0, _actionType.encodeActionType)(model.displayName, '@@CANCEL_EFFECTS'));

                                    case 2:
                                      _context.next = 4;
                                      return sagaEffects.cancel(task);

                                    case 4:
                                    case 'end':
                                      return _context.stop();
                                  }
                                }
                              }, _callee, this);
                            }));

                          case 6:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _loop, _this2);
                  });
                  _context3.t0 = _regenerator2.default.keys(model.effects);

                case 2:
                  if ((_context3.t1 = _context3.t0()).done) {
                    _context3.next = 7;
                    break;
                  }

                  key = _context3.t1.value;
                  return _context3.delegateYield(_loop(key), 't2', 5);

                case 5:
                  _context3.next = 2;
                  break;

                case 7:
                case 'end':
                  return _context3.stop();
              }
            }
          }, effect, this);
        });

        this._effects[model.displayName] = effect;
        return effect;
      }
    }

    // > see: https://redux-saga.js.org/docs/api/index.html#takepattern

  }, {
    key: '_createEffects',
    value: function _createEffects(model) {
      function put(action) {
        if (action.type) {
          var _decodeActionType3 = (0, _actionType.decodeActionType)(action.type),
              _decodeActionType4 = (0, _slicedToArray3.default)(_decodeActionType3, 2),
              modelName = _decodeActionType4[0],
              actionName = _decodeActionType4[1];

          if (!actionName && !model.actions[modelName]) {
            action.type = (0, _actionType.encodeActionType)(model.displayName, action.type);
          }
        } else {
          if (action.name) {
            if (action.name.indexOf('.') === -1) {
              action.name = (0, _actionType.typeToAction)(model.displayName, action.name);
            }
          } else {
            model._emitter.data = action;
            action = {
              type: model.ACTION_TYPE_IMMEDIATE,
              payload: action
            };
          }
        }
        return sagaEffects.put(action);
      }
      function take(type) {
        (0, _warning2.default)(!type, _messages2.default.dispatchType, 'take(...)', 'Beatle.saga');
        if (type) {
          var _decodeActionType5 = (0, _actionType.decodeActionType)(type),
              _decodeActionType6 = (0, _slicedToArray3.default)(_decodeActionType5, 2),
              modelName = _decodeActionType6[0],
              actionName = _decodeActionType6[1];

          if (!actionName && !model.actions[modelName]) {
            type = (0, _actionType.encodeActionType)(model.displayName, type);
          }
        }
        return sagaEffects.take(type);
      }

      return (0, _extends3.default)({}, sagaEffects, { put: put, take: take });
    }
  }, {
    key: '_getWatcher',
    value: function _getWatcher(model, actionName, action) {
      var self = this;
      var type = 'takeEvery';
      var ms = void 0;
      if (Array.isArray(action)) {
        var opts = action[1];
        action = action[0];
        if (opts && opts.type) {
          type = opts.type;
          if (type === 'throttle') {
            ms = opts.ms;
            (0, _warning2.default)(!ms, _messages2.default.throttle, 'interval', 'throttle', 'Beatle.Saga');
          }
        }
      }

      var prefix = (0, _actionType.encodeActionType)(model.displayName, actionName);
      var sagaWithCatch = /*#__PURE__*/_regenerator2.default.mark(function sagaWithCatch(option) {
        var args;
        return _regenerator2.default.wrap(function sagaWithCatch$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                args = option.payload && (option.payload.store || option.payload.arguments) ? option.payload.arguments || [] : [option];
                _context4.next = 4;
                return sagaEffects.put({ type: (0, _actionType.encodeActionType)(prefix, 'start') });

              case 4:
                _context4.next = 6;
                return action.apply(undefined, (0, _toConsumableArray3.default)(args.concat(model._emitter)));

              case 6:
                _context4.next = 8;
                return sagaEffects.put({ type: (0, _actionType.encodeActionType)(prefix, 'success') });

              case 8:
                self.resolve(prefix, model._emitter.data);
                _context4.next = 17;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](0);
                _context4.next = 15;
                return sagaEffects.put({ type: (0, _actionType.encodeActionType)(prefix, 'error') });

              case 15:
                self.reject(prefix, _context4.t0);
                window.console.error(_context4.t0);

              case 17:
              case 'end':
                return _context4.stop();
            }
          }
        }, sagaWithCatch, this, [[0, 11]]);
      });

      var sgaWorkersMap = {
        // watcher: sagaWithCatch,
        takeEvery: /*#__PURE__*/_regenerator2.default.mark(function takeEvery() {
          return _regenerator2.default.wrap(function takeEvery$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return (0, _sagaHelpers.takeEveryHelper)(prefix, sagaWithCatch);

                case 2:
                case 'end':
                  return _context5.stop();
              }
            }
          }, takeEvery, this);
        }),
        takeLatest: /*#__PURE__*/_regenerator2.default.mark(function takeLatest() {
          return _regenerator2.default.wrap(function takeLatest$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return (0, _sagaHelpers.takeLatestHelper)(ms, prefix, sagaWithCatch);

                case 2:
                case 'end':
                  return _context6.stop();
              }
            }
          }, takeLatest, this);
        }),
        throttle: /*#__PURE__*/_regenerator2.default.mark(function throttle() {
          return _regenerator2.default.wrap(function throttle$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return (0, _sagaHelpers.throttleHelper)(prefix, sagaWithCatch);

                case 2:
                case 'end':
                  return _context7.stop();
              }
            }
          }, throttle, this);
        })
      };

      (0, _warning2.default)(!!sgaWorkersMap[type], _messages2.default.worker, Object.keys(sgaWorkersMap), 'Beatle.Saga');

      return sgaWorkersMap[type];
    }
  }]);
  return Saga;
}();

exports.default = Saga;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/seed/saga.js
// module id = 164
// module chunks = 0